const loadingLabel = "Laeb";
const etEE = {
  loadingLabel
};
export {
  etEE as default,
  loadingLabel
};
